<template>
  <div class="dialog-slot">
    <button
      :data-reveal-id="id"
      v-if="modalBtn || allowEmptyBtnName"
      class="btn"
      :disabled="disableBtn"
      :class="modalBtnClass"
      @click.stop.prevent="handleOpenClick()"
    >{{ modalBtn }}</button>

    <Modal
      :modalId="id"
      ref="dialogSlot"
      :showCloseBtn="showCloseBtn"
      :beforeCloseModal="beforeCloseModal"
    >
      <p
        class="modal-pure-text"
        v-if="modalHeader"
      >{{ modalHeader }}</p>
      <div slot="content">
        <slot name="content" />
      </div>
      <div slot="btns">
        <slot name="buttons" />
      </div>
    </Modal>
  </div>
</template>

<script>
import Modal from './Modal'

export default {
  name: 'DialogSlot',
  props: {
    id: {
      type: String,
      required: true,
    },
    modalBtn: String,
    modalHeader: String,
    modalBtnClass: {
      type: String,
      default: 'btn--orange',
    },
    showCloseBtn: {
      type: Boolean,
      default: true,
    },
    disableBtn: {
      type: Boolean,
      default: false,
    },
    allowEmptyBtnName: {
      type: Boolean,
      default: false,
    },
    beforeOpenModal: {
      type: Function,
      default: () => { return true },
    },
    afterOpenModal: {
      type: Function,
      default: () => {},
    },
    beforeCloseModal: {
      type: Function,
      default: () => {},
    },
    afterCloseModal: {
      type: Function,
      default: () => {},
    },
  },
  components: {
    Modal,
  },
  methods: {
    async handleOpenClick (event) {
      const open = await this.beforeOpenModal()
      if (open) {
        this.openModal()
        await this.afterOpenModal()
      }
    },

    openModal () {
      this.$refs.dialogSlot.open()
    },

    async closeModal () {
      await this.beforeCloseModal()
      this.$refs.dialogSlot.close()
      await this.afterCloseModal()
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~styles/popup'
</style>
